import { render, staticRenderFns } from "./yhgl.vue?vue&type=template&id=d55b9518&scoped=true"
import script from "./yhgl.vue?vue&type=script&lang=js"
export * from "./yhgl.vue?vue&type=script&lang=js"
import style0 from "./yhgl.vue?vue&type=style&index=0&id=d55b9518&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d55b9518",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d55b9518')) {
      api.createRecord('d55b9518', component.options)
    } else {
      api.reload('d55b9518', component.options)
    }
    module.hot.accept("./yhgl.vue?vue&type=template&id=d55b9518&scoped=true", function () {
      api.rerender('d55b9518', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/sysConfig/yhgl.vue"
export default component.exports